import { InfoCircleOutlined } from "@ant-design/icons"
import { Button, Card, Col, Form, Input, Result, Row, Select, Space, Typography, message } from "antd"
import axios from "axios"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { token_client_id, token_url } from "../login/setting"

const ChildrenBinding = ({

}) => {
    const [form] = Form.useForm()
    const { StudentId } = useParams()
    const [relation, setRelation] = useState([])
    const [student, setStudent] = useState([])
    const [user, setUser] = useState([])
    const [emergencyContactList, setEmergencyContactList] = useState([])
    const [results, setResults] = useState(null)
    const [subTitle,setSubTitle] = useState('')
    const getRelation = () => {
        axios
            .get('/cramSchool/api/relation')
            .then(response => {
                setRelation(response.data.data)
            })
    }
    const getUser = () => {
        axios
            .get('/system/user_per')
            .then(response => {
                setUser(response.data.data.find(_=>true))
            })
    }
    const getStudent = () => {
        axios
            .get('/cramSchool/api/student', {
                params: {
                    student_id: StudentId
                }
            })
            .then(response => {
                let studentData = response.data?.data.find(e => true)
                let emergencyContactData = studentData?.emergency_contact ?? []
                setStudent(studentData)
                setEmergencyContactList(emergencyContactData)
            })
    }
    const relationValue = Form.useWatch('relation_id', form);
    const onEmergencyContactChange = (emergency_contact_id) => {
        let emergencyContactPerDataPer = emergencyContactList?.find((element) => element?.emergency_contact_id === emergency_contact_id)
        let formData = form?.getFieldsValue()
        form.setFieldsValue({
            ...formData,
            ...emergencyContactPerDataPer
        })
    }
    const onSuccess = () => {
        if(!user?.line_notify_token){
            setSubTitle("尚未綁定Line Notify，系統即將自動跳轉前往綁定")
            setTimeout(()=>{
                window.location.href=`/cramschool/NotifyBind`
            },2000)
        }else{
            setSubTitle("綁定完成，可以將網頁關閉囉")
        }
        setResults("success")
    }
    const onError = () => {
        setSubTitle("綁定失敗，可以再嘗試一次，或是聯絡我們")
        setResults("error")
    }

    useEffect(() => {
        getRelation()
        getStudent()
        getUser()
    }, [])
    return (<Row>
        {
            results && (
                <Col span={24}>
                    <Result
                        status={results}
                        title={results === "success" ? "成功" : "失敗"}
                        subTitle={subTitle}
                        extra={
                            results === "success" ? [] : [
                                <Button type="primary" onClick={() => { setResults(null) }} >
                                    再試一次
                                </Button>,

                            ]
                        }
                    />
                </Col>
            )
        }
        {
            !results && <Col span={24}>
                <Card
                    headStyle={{
                        backgroundColor: 'rgb(207,230,240'
                    }}
                    title={<>請完整填寫以下資料<Typography.Text type={'danger'}>（*為必填）</Typography.Text></>}
                >
                    <Row gutter={[24, 24]}>
                        <Col
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                        >
                            <Form
                                autoComplete="off"
                                form={form}
                                onFinish={(values) => {
                                    if (values?.emergency_contact_id !== "尚未新增") {
                                        axios
                                            .patch('/cramSchool/api/emergency_contact_per', [
                                                {
                                                    ...values,
                                                    relation_id: values?.relation_id === "其他" ? null : values?.relation_id,
                                                    // emergency_contact_phone_number: values['emergency_contact_phone_number'].join(''),
                                                    relation_user_id: student['user_id']
                                                }
                                            ])
                                            .then(response => {
                                                // message.success('綁定成功')
                                                onSuccess()
                                            })
                                            .catch(() => {
                                                // message.success('綁定失敗')
                                                onError()
                                            })
                                    }
                                    else {
                                        let postData = values
                                        delete postData.emergency_contact_id
                                        axios
                                            .post('/cramSchool/api/emergency_contact_per', [
                                                {
                                                    ...values,
                                                    relation_id: values?.relation_id === "其他" ? null : values?.relation_id,
                                                    // emergency_contact_phone_number: values['emergency_contact_phone_number'].join(''),
                                                    relation_user_id: student['user_id']
                                                }
                                            ])
                                            .then(response => {
                                                // message.success('綁定成功')
                                                onSuccess()
                                            })
                                            .catch(() => {
                                                // message.success('綁定失敗')
                                                onError()

                                            })
                                    }
                                }}
                            >
                                {/* {student.map(map_item => (<> */}
                                <Col span={24}>
                                    現在綁定的學生是：{student.name}
                                </Col>
                                {/* </>))} */}
                                <Col span={24}>
                                    <Form.Item
                                        label={'選擇家長'}
                                        name={'emergency_contact_id'}
                                        rules={[
                                            {
                                                required: true,
                                                message: "請選擇"
                                            }
                                        ]}
                                        tooltip={{
                                            title: '若在選單中沒有看到您的名字，請選擇“尚未新增”並填寫以下資訊喔～',
                                            icon: <InfoCircleOutlined />,
                                        }}
                                    >
                                        <Select
                                            allowClear={true}
                                            showSearch
                                            optionFilterProp="children"
                                            options={emergencyContactList.map(item => ({ label: item?.emergency_contact_name, value: item?.emergency_contact_id })).concat([
                                                { value: '尚未新增', label: '尚未新增' },
                                            ])}
                                            filterOption={(input, option) => {
                                                return (option?.label ?? '').includes(input)
                                            }}
                                            onChange={(value) => {
                                                onEmergencyContactChange(value)
                                            }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        rules={[
                                            {
                                                required: true,
                                                message: "請輸入您的姓名"
                                            }
                                        ]}
                                        label={'姓名'}
                                        name={'emergency_contact_name'}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        label={'關係'}
                                        name={'relation_id'}
                                        rules={[
                                            {
                                                required: true,
                                                message: "請選擇關係"
                                            }
                                        ]}
                                    >
                                        <Select
                                            options={relation.map(map_item => ({ label: map_item.name, value: map_item.relation_id })).concat([
                                                { value: '其他', label: null },
                                            ])}
                                        />
                                    </Form.Item>
                                    {relationValue === "其他" &&
                                        <Form.Item
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "請填寫您與學生的關係"
                                                }
                                            ]}
                                            label={"填寫"}
                                            name={'relation_name'}
                                        >
                                            <Input />
                                        </Form.Item>}
                                    <Form.Item
                                        label={'手機'}
                                        name={"emergency_contact_phone_number"}
                                        rules={[
                                            { transform: (value) => value.trim() },
                                        ]}

                                    >
                                        <Input
                                            maxLength={10}
                                        // style={{ width: '100px' }}
                                        />
                                    </Form.Item>
                                    
                                </Col>
                                <Col span={24}>
                                    <Button type="primary" htmlType="submit" block>送出</Button>
                                </Col>
                            </Form>
                        </Col>
                    </Row>
                </Card >
            </Col>
        }


    </Row>)
}
export default ChildrenBinding